module.exports = __webpack_public_path__ + "img/top@2x.5282c27f.png";